/** @format */

import $ from "jquery";
import axios from "axios";
import { Input } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";

import Card from "../../../../components/Card";
import print from "../../../../icons/print.png";
import excel from "../../../../icons/excel.png";
import { useReactToPrint } from "react-to-print";
import Minimap from "../../../../components/map/Minimap";
import Chart2 from "../../../../components/Charts/Chart2";
import { header } from "../../../../components/api/Header";
import { ExcelPrint } from "../../../../components/functions/Print";
import LoadingCard from "../../../../components/loading/loadingCard";
import { getEnv } from "../../../../lib/env";

function Oylik({ region, vaqt, search, havza }) {
  const conponentPDF = useRef();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState("");

  const [year, setYear] = useState(new Date().toISOString().slice(0, 4));
  const [lyear, setLyear] = useState(year);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await axios.get(
          `${getEnv('REACT_APP_BASE_URL')}/v1/region/asosiymanbalar/oylik?year=${year}&vaqt=${vaqt}&havza=${havza}`,
          header()
        );
        if (res) {
          if (region === "Gidromet") {
            const indicesByHavza = {
              1: [
                23, 24, 25, 26, 27, 28, 29, 30, 35, 36, 37, 38, 39, 40, 41, 42,
                43, 44, 45, 46, 47, 59, 60, 61, 62,
              ],
              2: [
                0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17,
                18, 19, 20, 21, 22, 31, 32, 33, 34, 48, 49, 50, 51, 52, 53, 54,
                55, 56, 57, 58,
              ],
            };
            if (indicesByHavza[havza]) {
              setData(indicesByHavza[havza].map((i) => res.data[i]));
            } else {
              setData(res.data);
            }
          } else {
            setData(res.data);
          }
        }
      } catch (e) {
        console.log("Xato", e);
        alert("Serverga ulanishda xato!");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [year, vaqt, havza]);

  useEffect(() => {
    setYear(lyear);
  }, [lyear]);

  const chiz = (index) => {
    removeChecked();
    let v = $("tr.tr" + index + " input");
    let checked = v[0].checked;
    v[0].checked = !checked;
    if (!checked) {
      $("tr.tr" + index).addClass("active");
    } else {
      $("tr.tr" + index).removeClass("active");
    }
    setSelectedRowKeys(index);
  };

  const removeChecked = () => {
    if (selectedRowKeys !== "") {
      $("tr.tr" + selectedRowKeys + " input")[0].checked = false;
      $("tr.tr" + selectedRowKeys).removeClass("active");
    }
  };

  const close = () => {
    if (selectedRowKeys !== "") {
      $("tr.tr" + selectedRowKeys + " input")[0].checked = false;
      $("tr.tr" + selectedRowKeys).removeClass("active");
    }
    setSelectedRowKeys("");
  };

  const labels = [
    "Yanvar",
    "Fevral",
    "Mart",
    "Aprel",
    "May",
    "Iyun",
    "Iyul",
    "Avgust",
    "Sentyabr",
    "Oktyabr",
    "Noyabr",
    "Dekabr",
  ];

  const generatePDF = useReactToPrint({
    content: () => conponentPDF.current,
    documentTitle: "Asosiy manbalar",
  });

  return (
    <>
      <div className='table-box'>
        <div className='table-content-top'>
          <div className='table-top-left'>
            <Input
              prefix={<SearchOutlined className='site-form-item-icon' />}
              placeholder='Search'
              onChange={(e) => search(e.target.value)}
            />
          </div>

          <ul className='table-top-right'>
            <li>
              <div className='d-flex'>
                <input
                  type='number'
                  className='form-control form-control-sm'
                  value={lyear}
                  onChange={(e) => setLyear(e.target.value)}
                />
              </div>
            </li>

            <li>
              <button className='btn p-0' onClick={() => generatePDF(".table")}>
                <img src={print} alt='404' />
              </button>
            </li>

            <li>
              <button
                className='btn p-0'
                onClick={() =>
                  ExcelPrint("Asosiy manbalar " + region, year, "tblData")
                }>
                <img src={excel} alt='404' />
              </button>
            </li>
          </ul>
        </div>

        {loading ? (
          <LoadingCard loading={loading} heightSize='80vh' />
        ) : (
          <div id='content'>
            <div
              id='tableFlexible'
              style={{ height: selectedRowKeys === "" ? "80vh" : "38vh" }}>
              <div ref={conponentPDF} style={{ width: "100%" }}>
                <table
                  id='tblData'
                  className='table table-bordered table-style fixedHeader'>
                  <thead className=''>
                    <tr>
                      <th rowSpan={2} className='sticky st1'>
                        o
                      </th>

                      <th
                        rowSpan={2}
                        className='sticky'
                        style={{ left: "31px" }}>
                        T/R
                      </th>

                      <th
                        rowSpan={2}
                        className='sticky'
                        style={{ left: "71px", width: "250px" }}>
                        Irrigatsiya tizimlari nomi va asosiy suvolish nuqtalari
                      </th>

                      <th
                        rowSpan={2}
                        className='sticky'
                        style={{ left: "368px" }}>
                        O’lchov birligi
                      </th>

                      <th colSpan={12} className='text-center'>
                        {year}
                      </th>
                    </tr>

                    <tr>
                      <th>Yanvar</th>

                      <th>Fevral</th>

                      <th>Mart</th>

                      <th>Aprel</th>

                      <th>May</th>

                      <th>Iyun</th>

                      <th>Iyul</th>

                      <th>Avgust</th>

                      <th>Sentyabr</th>

                      <th>Oktyabr</th>

                      <th>Noyabr</th>

                      <th>Dekabr</th>
                    </tr>
                  </thead>

                  {data.length > 0
                    ? data.map((d, index) => {
                        return (
                          <tbody key={index}>
                            <tr
                              onClick={() => chiz(index)}
                              className={"tr tr" + index}>
                              <td className='sticky st1'>
                                <input type='checkbox' />
                              </td>

                              <td className='sticky' style={{ left: "31px" }}>
                                {index + 1}
                              </td>

                              <td
                                className='text-start sticky fix-with'
                                style={{ left: "71px" }}>
                                {d.manba_nomi}
                              </td>

                              <td
                                className='text-start sticky'
                                style={{ left: "368px" }}>
                                {d.birligi}
                              </td>

                              {d.data
                                ? d.data.map((s, i) => {
                                    return (
                                      <td
                                        style={{
                                          width: "120px",
                                          maxWidth: "120px",
                                          minWidth: "120px",
                                        }}
                                        key={i}>
                                        {s}
                                      </td>
                                    );
                                  })
                                : Array(12)
                                    .fill()
                                    .map((i) => {
                                      return (
                                        <td
                                          style={{
                                            width: "120px",
                                            maxWidth: "120px",
                                            minWidth: "120px",
                                          }}
                                          key={i}></td>
                                      );
                                    })}
                            </tr>
                          </tbody>
                        );
                      })
                    : null}
                </table>
              </div>
            </div>
          </div>
        )}
      </div>

      {selectedRowKeys.length === 0 ? null : (
        <div
          className='data-content mt-3 mainpage'
          style={{ position: "relative" }}>
          <CloseOutlined
            style={{
              position: "absolute",
              top: 0,
              right: 10,
              zIndex: 9,
              fontSize: "20px",
              cursor: "pointer",
            }}
            onClick={close}
          />

          <Card>
            {data[selectedRowKeys].lat !== null &&
            data[selectedRowKeys].lan !== null ? (
              <Minimap
                location={[
                  data[selectedRowKeys].lat,
                  data[selectedRowKeys].lan,
                ]}
                locations={[]}
                zoom={13}
              />
            ) : null}
          </Card>

          <Chart2 datas={data[selectedRowKeys]["data"]} labels={labels} />
        </div>
      )}
    </>
  );
}

export default Oylik;
